import { render } from "./resignation-table.vue?vue&type=template&id=3e69f63a"
import script from "./resignation-table.vue?vue&type=script&lang=js"
export * from "./resignation-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__